import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';
import { IonicPage, NavController, NavParams, Platform, ViewController } from 'ionic-angular';
import { StoryProvider } from '../../providers/story/story';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import * as firebase from 'firebase';
import 'firebase/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import * as moment from "moment";


@IonicPage()
@Component({
  selector: 'page-comment',
  templateUrl: 'comment.html',
})

export class CommentPage {
  @ViewChild(Content) content: Content;

  private db: any;
  public comments: any;
  public id_storie: any;
  public data: any;
  public username: any;
  public inputComment: any;
  public photo: any;
  public date: any;
  public showNoMessage: boolean = false;
  public gender: any;
  public session: boolean;
  public myPhoto: any;
  public userinfo: any;


  constructor(
    public afsModule: AngularFirestore,
    public platform: Platform,
    public params: NavParams,
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public storyProvider: StoryProvider,
    public firestore: AngularFirestore,
    public auth: AuthDataProvider,
  ) {
    this.db = firebase.firestore();
    this.date = moment().format('DD/MM/YYYY');
    console.log("FECHA", this.date);

  }

  ionViewWillEnter() {
    let ion = this;
    let data = this.navParams.get('data');
    console.log(" COMENTARIOS:", data.comments);
    ion.comments = data.comments;
    ion.session = data.session;
    ion.userinfo = data.userinfo;
    console.log("INICIO DE SESION ES:", ion.session);
    console.log("Informacion del Usuario Logueado", ion.userinfo);
    ion.data = data;
    ion.auth.getUserProfile().then(resdevice => {
      ion.username = ion.userinfo.username
      ion.photo = resdevice.photo
      ion.gender = resdevice.gender
      console.log("USERNAME ", ion.username)
      // console.log("FOTO DE PERFIL", resdevice.photo);
      if (ion.photo === 'default' && ion.gender === 'M') {
        this.myPhoto = "/../../assets/imgs/male.jpg";
        if (ion.photo === 'default' && ion.gender === 'F') {
          this.myPhoto = "/../../assets/imgs/female.jpg";
        }
      } else {
        this.myPhoto = ion.photo;
      }
      console.log("MYPHOTO", this.myPhoto);
    });
    // this.checkNoComments();
  }

  // checkNoComments() {
  //   let ion = this;
  //   if (!ion.data.comments || ion.data.comments.length === 0) {
  //     ion.showNoMessage = true;
  //   }
  // }

  // Function to send comments
  sendComment(comment) {
    let ion = this;
    // Se toman los comentarios que vienen firestore y se le inserta el nuevo comentario y se muestra en la vista
    if (comment == "") {
      console.log("DEBE AGREGAR UN COMENTARIO PARA ENVIAR");

    } else {
      if (ion.comments && ion.data.comments.length !== 0 && comment !== "") {
        console.log("OOOOOOOOOOOOOOOOOO", comment);

        ion.comments.unshift({
          comment: comment,
          username: ion.username,
          date: ion.date,
          photo: this.myPhoto
        });
        ion.inputComment = "";
        console.log('EL NUEVO COMENTARIO SE HA AÑADIDO', ion.comments);
        ion.db.collection("stories").doc(ion.data.id_storie).update({ comments: ion.comments })
          .then(function () {
            console.log("Comment added!");
          })
          .catch(function (error) {
            console.error("Error updating comment: ", error);
          });
        ion.inputComment = "";
      }
    }
    if (ion.comments && ion.data.comments.length === 0) {
      ion.db.collection("stories").doc(ion.data.id_storie).update({
        comments: [
          {
            comment: comment,
            username: ion.username,
            date: ion.date,
            photo: this.myPhoto
          }
        ]
      }).then(function () {
        console.log("Comment successfully written!");
      })
        .catch(function (error) {
          console.error("Error writing comment: ", error);
        });
      ion.comments.unshift({
        comment: comment,
        username: ion.username,
        date: ion.date,
        photo: this.myPhoto
      });
      ion.inputComment = "";
      this.content.scrollToTop();
    }
  }
} 


// WEBPACK FOOTER //
// ./src/pages/comment/comment.ts